import { PaintedScene } from '../PaintedScene';

export const DUNE_CREST_WANDER_PHASER_KEY = 'DuneCrestWanderScene' as const;
export const DUNE_CREST_WANDER_MANIFEST_KEY = 's-210-dune-crest-wander' as const;

export class DuneCrestWanderScene extends PaintedScene {
  constructor() {
    super(DUNE_CREST_WANDER_PHASER_KEY, DUNE_CREST_WANDER_MANIFEST_KEY);
  }
}
